import { render, staticRenderFns } from "./interview-quizzes-q-ans-add.html?vue&type=template&id=5608fd16&scoped=true&"
import script from "./interview-quizzes-q-ans-add.js?vue&type=script&lang=js&"
export * from "./interview-quizzes-q-ans-add.js?vue&type=script&lang=js&"
import style0 from "./interview-quizzes-q-ans-add.scss?vue&type=style&index=0&id=5608fd16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608fd16",
  null
  
)

export default component.exports